import { render, staticRenderFns } from "./ViewDelivery.vue?vue&type=template&id=414a4046&"
import script from "./ViewDelivery.vue?vue&type=script&lang=js&"
export * from "./ViewDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports